<template>
    <v-card class="pa-5 margin-bottom">
        <v-row class="mx-2 mt-0 pt-0">
            <v-col cols="12" class="text-center mt-0 pt-0">
                <v-btn class="mt-4 generate-btn-margin" small color="success"
                       @click="handleGenerateClick">Generate current data
                </v-btn>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'DataAnalyticsRecommendationGenerateCard',
    methods: {
        ...mapActions('analytics', ['generateCsvFile', 'getAnalyticsRecommendationDataTableData']),
        async handleGenerateClick() {
            await this.generateCsvFile({type: 'recommendation'});
            await this.getAnalyticsRecommendationDataTableData();
        },
    },
};
</script>

<style scoped>

</style>